<template>
  <div class="add-box">
    <el-form ref="roleform" :model="roleform" label-width="120px" class="user-form">
      <el-form-item label="角色名称:">
        <el-input v-model="roleform.roleName" placeholder="角色名称" class="user-input" />
      </el-form-item>
      <el-form-item label="所属部门:">
        <el-cascader
          ref="lastdept"
          :show-all-levels="false"
          :options="lastdeptList"
          :props="optionProps"
          class="user-input"
          placeholder="所属部门"
          @change="lastdeptChange"
        />
      </el-form-item>

      <el-form-item label="功能权限:">
        <el-cascader
          clearable
          :options="menuList"
          :props="menuProps"
          :collapse-tags="true"
          class="user-input"
          @change="menuChange"
        />
      </el-form-item>

      <el-form-item label="数据权限:">
        <el-cascader
          :show-all-levels="false"
          :options="deptList"
          :props="deptProps"
          class="user-input"
          @change="deptChange"
        />
      </el-form-item>

      <el-form-item label="备注:">
        <el-input
          v-model="roleform.remark"
          type="textarea"
          :rows="4"
          placeholder="备注"
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click.prevent="save">确定</el-button>
        <el-button type="warning" @click.prevent="back">返回</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
export default {
	    data() {
    return {
      lastdeptList: [],
      deptList: [],
      menuList: [],
      optionProps: {
        expandTrigger: 'hover',
        emitPath: false,
        value: 'deptId',
        label: 'name',
        children: 'children'
      },

      menuProps: {
        multiple: true,
        emitPath: true,
        expandTrigger: 'hover',
        value: 'menuId',
        label: 'name',
        children: 'children'
      },

      deptProps: {
        multiple: true,
        emitPath: false,
        expandTrigger: 'hover',
        value: 'deptId',
        label: 'name',
        children: 'children'
      },

      roleform: {
        roleName: '',
        deptId: '',
        menuIdList: null,
        deptIdList: [],
        remark: ''
      }
    }
	    },

  created() {
    this.$emit('setCurrentMenu', '角色管理')
    this.getdeptList()
    this.getmenuList()
  },

	    methods: {
    getdeptList() {
      const vm = this
      vm.axios.get(vm.homePath() + '/sys/dept/list')
        .then(res => {
          const data = res.data
          vm.lastdeptList = vm.filterNull(vm.toTreeData(data, 'parentId', 'deptId'))
          vm.deptList = vm.lastdeptList
        })
        .catch(error => console.log(error))
    },

    getmenuList() {
      const vm = this
      vm.axios.get(vm.homePath() + '/sys/menu/list')
        .then(res => {
          const data = res.data
          vm.menuList = vm.filterNull(vm.toTreeData(data, 'parentId', 'menuId'))
        })
        .catch(error => console.log(error))
    },

    filterNull(data) {
      const vm = this
      for (var i = 0; i < data.length; i++) {
				    if (data[i].children.length < 1) {
				        data[i].children = undefined
				    } else {
				        vm.filterNull(data[i].children)
				    }
      }
      return data
    },

    lastdeptChange(val) {
      this.roleform.deptId = val
      this.roleform.deptName = this.$refs['lastdept'].getCheckedNodes()[0].label
    },

    deptChange(val) {
      this.roleform.deptIdList = val
    },

    menuChange(val) {
      this.roleform.menuIdList = this.unique(val.join(',').split(','))
    },

    save() {
      let past = true
      if (this.roleform.roleName == '') {
        this.$alert('角色名称不能为空', '提示')
        past = false
      }
      if (this.roleform.deptId == '') {
        this.$alert('所属部门不能为空', '提示')
        past = false
      }
      if (this.menuSelect == []) {
        this.$alert('请选择功能权限', '提示')
        past = false
      }

      if (this.deptSelect == []) {
        this.$alert('请选择数据权限', '提示')
        past = false
      }

      if (this.remark == '') {
        this.$alert('备注不能为空', '提示')
        past = false
      }

      if (past) {
        const vm = this
        vm.axios.post(vm.homePath() + '/sys/role/save', {
          roleName: vm.roleform.roleName,
          deptId: vm.roleform.deptId,
          deptName: vm.roleform.deptName,
          menuIdList: vm.roleform.menuIdList,
          deptIdList: vm.roleform.deptIdList,
          remark: vm.roleform.remark
        })
          .then(response => {
            if (response.data.status == '000000') {
              vm.$alert('增加成功', '提示', {
                callback: action => {
                  vm.$router.push('/index/role')
                }
              })
            } else {
              vm.$alert(response.data.message, '提示')
            }
          })
          .catch(error => console.log(error))
      }
    },

    back() {
      this.$router.push('/index/role')
    }
	    }
	  }
</script>

<style>
</style>

